import { Component } from '@angular/core';

@Component({
    selector: 'app-logout-confirm',
    templateUrl: './logout-confirm.component.html',
    styleUrls: ['./logout-confirm.component.scss'],
    standalone: false
})
export class LogoutConfirmComponent {
}
